interface QueryStatus {
    isLoading?: boolean;
    isError?: boolean;
    isSuccess?: boolean;
    isFetching?: boolean;
}

export function mergeQueryStatuses(...statuses: Array<QueryStatus>) {
    return statuses.reduce(
        (acc, status) => ({
            isLoading: acc.isLoading || status.isLoading,
            isError: acc.isError || status.isError,
            isSuccess: acc.isSuccess && status.isSuccess,
            isFetching: acc.isFetching || status.isFetching,
        }),
        { isLoading: false, isFetching: false, isError: false, isSuccess: true }
    );
}
